
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'
import { Image } from 'components/image'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3>Les chiffres</h3>
    <p className='fact'>
  Environ <b>80% des maladies infectieuses</b> sont transmises par les mains.
    </p>
    <p className='fact'>
  En moyenne, nous nous touchons le visage avec nos mains <b>16 fois par heure</b>. C'est ainsi que les germes pénètrent dans notre corps par les muqueuses.
    </p>
    <p className='fact last'>
Le risque d'infection par des virus et des bactéries peut être réduit jusqu'à <b>99,9% en se lavant correctement</b> les mains.
    </p>
    <p>
Malgré ces résultats, il est alarmant de constater que pratiquement toutes les études montrent que l’immense majorité ne se lave pas les mains correctement:
  </p>
    <ul>
  <li>
    Des étudiantes en psychologie appliquée de <Link href='https://www.hochschule-heidelberg.de/de/news-detail/news/alarmierend-nur-8-waschen-ihre-haende-in-korrekter-weise/' allowWordWrap mdxType="Link">l'Université de Heidelberg</Link>  ont observé les doigts de 1000 usagers des WC. Leurs conclusions? 7% ne se sont pas du tout lavé les mains, 11% des hommes et 3% des femmes. 27% se lavent les mains uniquement à l'eau, et environ 58% utilisent de l'eau et du savon, mais pas avec la minutie nécessaire. Seuls 8% se sont lavé les mains de manière exemplaire.
  </li>
  <li>
    Une étude de <Link href='https://msutoday.msu.edu/_/pdf/assets/2013/hand-washing-study.pdf' allowWordWrap mdxType="Link">l'Université du Michigan</Link> est arrivée à des conclusions similaires: seulement 5% des personnes se lavent les mains correctement. 3749 personnes ont été observées dans les toilettes publiques. Une sur dix ne se lave pas du tout les mains, environ un tiers n'utilise pas de savon. Ici aussi, les hommes, en particulier, sont négligents lorsqu'il s'agit de se laver les mains. 15% des hommes ne se lavent pas du tout les mains, contre seulement 7% des femmes. Le contact des mains avec les hommes comporte donc un risque de transmission plus élevé.
  </li>
  <li>
Une autre étude a été menée par le Ministère américain de l'agriculture en coopération avec l'université d'État de Caroline du Nord. Les caméras ont documenté la façon dont 383 sujets de test ont préparé deux repas. Beaucoup d'entre eux se sont lavé les mains, mais il s'est avéré qu'ils l'ont mal fait. Il est choquant de constater que pas moins de 24% n'utilisent pas de savon. Et presque personne n'avait fait mousser ses mains avec du savon pendant au moins vingt secondes.
  </li>
  <li>
L'importance du lavage des mains est également méconnue: en 2012, le Centre fédéral allemand pour l'éducation à la santé a commandé une enquête téléphonique sur le comportement de la population en matière d'hygiène. Parmi les quelque 4500 personnes interrogées, seule une sur deux savait qu'il était possible que des personnes puissent être infectées par des maladies via leurs propres mains.
  </li>
  <li>
    Une <Link href='https://onlinelibrary.wiley.com/doi/full/10.1111/risa.13438' allowWordWrap mdxType="Link">étude très récente</Link> arrive à cette conclusion: se laver les mains à l'aéroport peut prévenir les épidémies. En moyenne, seules 20% des personnes présentes dans les aéroports ont les mains propres. «Les 80% restants contaminent potentiellement tout ce qu'ils touchent avec des virus et des bactéries», selon Christos Nicolaides, auteur de l'étude. Si 60% des voyageurs avaient les mains propres en tout temps, cela pourrait ralentir la propagation mondiale des maladies de près de 70%, notent les chercheurs.
     </li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;